import React from 'react';
import { CusProductListCategoriesSectionProps } from '../../cus-product-list.data';

export default function CategoriesSection({
    categories,
    selectedIds,
    onSelectionChange,
    categoriesFilterHeading
}: CusProductListCategoriesSectionProps) {
    const [isCollapsed, setIsCollapsed] = React.useState(false);
    const selectedSet = React.useMemo(() => new Set(selectedIds ?? []), [selectedIds]);

    const handleChange = (id: string, checked: boolean) => {
        const next = new Set(selectedSet);
        checked ? next.add(id) : next.delete(id);
        onSelectionChange?.(Array.from(next));
    };

    return (
        <section className='bs-product-list-filters__section'>
            <button
                type='button'
                className='bs-product-list-filters__section__title'
                onClick={() => setIsCollapsed(prev => !prev)}
                aria-expanded={!isCollapsed}
            >
                {categoriesFilterHeading}
                <span className='bs-product-list-filters__section__title__chevron' aria-hidden='true' />
            </button>
            <ul className={`bs-product-list-filters__list${isCollapsed ? ' --collapsed' : ''}`}>
                {categories.map(category => (
                    <li key={category.id} className='bs-product-list-filters__list__item'>
                        <label className='bs-product-list-filters__list__item__label'>
                            <span>{category.displayName}</span>
                            <input
                                type='checkbox'
                                className='bs-product-list-filters__list__item__checkbox'
                                checked={selectedSet.has(category.id)}
                                onChange={e => handleChange(category.id, e.target.checked)}
                            />
                        </label>
                    </li>
                ))}
            </ul>
        </section>
    );
}
